module.exports = __webpack_public_path__ + "img/palm-kids.4932338f.jpg";